<template>
  <div>
    <div v-if="loading">
      <v-overlay class="waitoverlay" :value="busy">
     <v-progress-circular
      indeterminate
      size="64"
      class="mr-4"
    /> {{ $t('global.loading') }}
    </v-overlay>
    </div>
    <div v-else-if="rawHtml" class="learner-report" v-html="rawHtml" />
    <div v-else-if="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
  import api from '@/helpers/api.js'
  export default {
    props: {
      sessionId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        rawHtml: null,
        loading: true,
        errorMessage: null,
      }
    },
    async mounted () {
      try {
        this.rawHtml = await api.getIPELearnerReport(this.sessionId)
        this.loading = false
      } catch (e) {
        console.log(e)
        // todo - catch a 404 and make learner report not found message
        this.loading = false
        this.errorMessage = this.$t('learnerReport.error')
      }
    },
  }
</script>

